import { useEffect, useState } from 'react';
import { Row, Col, Card, Alert } from 'react-bootstrap';
import { FaChalkboardTeacher, FaClock, FaUserGraduate, FaDollarSign } from 'react-icons/fa';
import { api } from '../api/client';
import './Dashboard.css';

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    api.get('/admin/dashboard')
      .then((d) => { if (alive) setData(d); })
      .catch((e) => { if (alive) setErr(e.message || 'Failed to load'); });
    return () => { alive = false; };
  }, []);

  const c = data?.counts || {};

  return (
    <>
      <h3 className="mb-4">Admin Dashboard</h3>

      {err && <Alert variant="danger">{err}</Alert>}

      <Row>
        <Col md={3}>
          <Card className="shadow mb-3">
            <Card.Body className="custom-teacher">
              <FaChalkboardTeacher size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">Total Teachers</Card.Title>
              <h4 className="text-white">{c.total_teachers ?? '-'}</h4>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="shadow mb-3">
            <Card.Body className="custom-pending">
              <FaClock size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">Pending Approvals</Card.Title>
              <h4 className="text-white">{c.pending_teachers ?? '-'}</h4>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="shadow mb-3">
            <Card.Body className="custom-student">
              <FaUserGraduate size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">Active Students</Card.Title>
              <h4 className="text-white">{c.total_students ?? '-'}</h4>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3}>
          <Card className="shadow mb-3">
            <Card.Body className="custom-profit">
              <FaDollarSign size={30} className="mb-2 text-white" />
              <Card.Title className="text-white">Total Revenue</Card.Title>
              <h4 className="text-white">₹{Number(c.total_revenue ?? 0).toFixed(2)}</h4>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card className="shadow mt-4">
        <Card.Body>
          <Card.Title>Platform</Card.Title>
          <p className="mb-1">Current commission: <strong>{data?.commission_pct ?? '-'}%</strong></p>
          <p className="text-muted small mb-0">
            Manage teachers, students, bookings and settlements from the sidebar.
          </p>
        </Card.Body>
      </Card>
    </>
  );
}
